import { parse as parseYaml } from "yaml";
import welcomePost from "../content/blog/welcome-to-better-insights.md";
import testPost from "../content/blog/test-post.md";
import completeGA4SystemPost from "../content/blog/complete-ga4-system-for-tracking-all-ai-traffic.md";

// Function to parse frontmatter from markdown content
function parseFrontmatter(content) {
  const frontmatterRegex = /^---\n([\s\S]*?)\n---\n([\s\S]*)$/;
  const match = content.match(frontmatterRegex);

  if (!match) {
    throw new Error("Invalid frontmatter format");
  }

  const [, frontmatter, markdown] = match;
  return {
    ...parseYaml(frontmatter),
    content: markdown.trim(),
  };
}

// Get the slug from the filename
function getSlugFromFilename(filename) {
  return filename.replace(/\.md$/, "");
}

// Define our blog posts
const blogPosts = [
  {
    path: "complete-ga4-system-for-tracking-all-ai-traffic.md",
    content: completeGA4SystemPost,
  },
  { path: "welcome-to-better-insights.md", content: welcomePost },
  { path: "test-post.md", content: testPost },
];

// Load all blog posts
export async function getAllPosts() {
  try {
    const posts = blogPosts
      .map((file) => {
        try {
          const slug = getSlugFromFilename(file.path);
          const post = parseFrontmatter(file.content);
          return { ...post, slug };
        } catch (error) {
          console.error(`Error processing blog post ${file.path}:`, error);
          return null;
        }
      })
      .filter(Boolean);

    // Sort posts by date (newest first)
    return posts.sort((a, b) => new Date(b.date) - new Date(a.date));
  } catch (error) {
    console.error("Error loading blog posts:", error);
    return [];
  }
}

// Get a single post by slug
export async function getPostBySlug(slug) {
  const posts = await getAllPosts();
  return posts.find((post) => post.slug === slug);
}
